import React, { useState } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { useTranslation } from "react-i18next";

const CreateRoleDialog = ({ open, allowCreate, onClose, onCreate }) => {
  const { t } = useTranslation("role/role_dialog", { useSuspense: false });
  const [roleName, setRoleName] = useState("");
  const [error, setError] = useState("");

  const handleCreate = () => {
    if (!allowCreate) {
      setError(t("errors.role_management_disabled"));
      return;
    }
    if (!roleName.trim()) {
      setError(t("errors.name_required"));
      return;
    }
    onCreate(roleName.trim());
    setRoleName("");
    setError("");
  };

  const handleClose = () => {
    setRoleName("");
    setError("");
    onClose();
  };

  if (!open) return null;

  return (
    <Dialog>
      <div className="p-1 px-2">
        <div className="d-flex align-items-center justify-content-between mb-4">
          <h5 className="fw-bold mb-0">{t("add_new_title")}</h5>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            style={{ zIndex: 2 }}
            onClick={handleClose}
          />
        </div>
        <div className="mb-3">
          <label className="form-label" required>{t("name_field_label")}</label>
          <input
            type="text"
            className="form-control"
            value={roleName}
            onChange={e => setRoleName(e.target.value)}
            placeholder={t("name_placeholder")}
            autoFocus
          />
          {error && <div style={{ color: "#d32f2f", fontSize: 13, marginTop: 4 }}>{error}</div>}
        </div>
        <DialogActionsBar layout="end">
          <button onClick={handleClose} className="btn btn-secondary">{t("buttons.cancel_button_label")}</button>
          <button onClick={handleCreate} className="btn btn-primary">{t("buttons.add_button_label")}</button>
        </DialogActionsBar>
      </div>
    </Dialog>
  );
};

export default CreateRoleDialog;
